import { render, staticRenderFns } from "./CUInficationOrder.vue?vue&type=template&id=15b20c99&scoped=true"
import script from "./CUInficationOrder.vue?vue&type=script&lang=js"
export * from "./CUInficationOrder.vue?vue&type=script&lang=js"
import style0 from "./CUInficationOrder.vue?vue&type=style&index=0&id=15b20c99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b20c99",
  null
  
)

export default component.exports